/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WarehouseResVo } from './WarehouseResVo';
import {
    WarehouseResVoFromJSON,
    WarehouseResVoFromJSONTyped,
    WarehouseResVoToJSON,
    WarehouseResVoToJSONTyped,
} from './WarehouseResVo';

/**
 * 
 * @export
 * @interface WarehouseNationGroupResVo
 */
export interface WarehouseNationGroupResVo {
    /**
     * 国家ID；未绑定时为 null
     * @type {number}
     * @memberof WarehouseNationGroupResVo
     */
    id?: number;
    /**
     * 国家名称（按当前请求语言）
     * @type {string}
     * @memberof WarehouseNationGroupResVo
     */
    name?: string;
    /**
     * 该国家下启用的仓库（字段与 GET /warehouse/all 单条一致）
     * @type {Array<WarehouseResVo>}
     * @memberof WarehouseNationGroupResVo
     */
    warehouses?: Array<WarehouseResVo>;
}

/**
 * Check if a given object implements the WarehouseNationGroupResVo interface.
 */
export function instanceOfWarehouseNationGroupResVo(value: object): value is WarehouseNationGroupResVo {
    return true;
}

export function WarehouseNationGroupResVoFromJSON(json: any): WarehouseNationGroupResVo {
    return WarehouseNationGroupResVoFromJSONTyped(json, false);
}

export function WarehouseNationGroupResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseNationGroupResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'warehouses': json['warehouses'] == null ? undefined : ((json['warehouses'] as Array<any>).map(WarehouseResVoFromJSON)),
    };
}

export function WarehouseNationGroupResVoToJSON(json: any): WarehouseNationGroupResVo {
    return WarehouseNationGroupResVoToJSONTyped(json, false);
}

export function WarehouseNationGroupResVoToJSONTyped(value?: WarehouseNationGroupResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'warehouses': value['warehouses'] == null ? undefined : ((value['warehouses'] as Array<any>).map(WarehouseResVoToJSON)),
    };
}

